import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import HomeMain from './components/Home/HomeMain';
import PrivacyPolicy from './components/PrivacyPolicy';
import Disclaimer from './components/Disclaimer';
import Depomain from './components/SubServices/depo/DepoMain.jsx'; 
import BabyfoodMain from './components/SubServices/babyfood/BabyFoodMain.jsx';
import ParaquatMain from './components/SubServices/paraquat/PraquatMain.jsx';
import RoundUpMain from './components/SubServices/roundup/RoundupMain.jsx';
import ServiceMain from './components/Service/ServiceMain.jsx';
import AboutUs from './components/AboutUs/AboutMain.jsx';
import ContactUs from './components/ContactUs/ContactMain.jsx'; 
import AFFFMain from './components/SubServices/AFFF/AFFFMain.jsx'; 
import BardPowerPortMain from './components/SubServices/BardPowerPort/BardPowerPortMain.jsx';
import TalcumMain from './components/SubServices/TalcumPowder/TalcumPowderMain.jsx';
import TransvaginalMain from './components/SubServices/TransvaginalMesh/TransvaginalMain.jsx';
import UltraProcessedMain from './components/SubServices/UltraProcessedFood/UltraProcessedMain.jsx';
import OxbrytaMain from './components/SubServices/Oxbryta/OxbrytaMain.jsx';
import PFASMain from './components/SubServices/PFAS/PFASMain.jsx';
import ReactGA  from 'react-ga4';
import DepoProveraLawsuit from './components/Lawsuits/DepoProveraLawsuit.jsx';
import TalcumPowderLawsuit from './components/Lawsuits/TalcumPowderLawsuit.jsx';
import HerniaMeshLawsuit from './components/Lawsuits/HerniaMeshLawsuit.jsx';
import OzempicLawsuit from './components/Lawsuits/OzempicLawsuit.jsx';
import HairRelaxerLawsuit from './components/Lawsuits/HairRelaxerLawsuit.jsx';
import RideshareSexualAssaultLawsuit from './components/Lawsuits/RideshareSexualAssaultLawsuit.jsx';
import SocialMediaAddictionLawsuit from './components/Lawsuits/SocialMediaAddictionLawsuit.jsx';
import RobloxSALawsuit from './components/Lawsuits/RobloxSALawsuit.jsx';
import RoundupLawsuit from './components/Lawsuits/RoundupLawsuit.jsx';
import DepoProveraLawsuitB from './components/Lawsuits/DepoProveraLawsuitB.jsx';
import TalcumPowderLawsuitB from './components/Lawsuits/TalcumPowderLawsuitB.jsx';
import HerniaMeshLawsuitB from './components/Lawsuits/HerniaMeshLawsuitB.jsx';
import OzempicLawsuitB from './components/Lawsuits/OzempicLawsuitB.jsx';
import HairRelaxerLawsuitB from './components/Lawsuits/HairRelaxerLawsuitB.jsx';
import RideshareSexualAssaultLawsuitB from './components/Lawsuits/RideshareSexualAssaultLawsuitB.jsx';
import SocialMediaAddictionLawsuitB from './components/Lawsuits/SocialMediaAddictionLawsuitB.jsx';
import RobloxSALawsuitB from './components/Lawsuits/RobloxSALawsuitB.jsx';
import DepoProveraLawsuitC from './components/Lawsuits/DepoProveraLawsuitC.jsx';
import TalcumPowderLawsuitC from './components/Lawsuits/TalcumPowderLawsuitC.jsx';
import HerniaMeshLawsuitC from './components/Lawsuits/HerniaMeshLawsuitC.jsx';
import OzempicLawsuitC from './components/Lawsuits/OzempicLawsuitC.jsx';
import HairRelaxerLawsuitC from './components/Lawsuits/HairRelaxerLawsuitC.jsx';
import RideshareSexualAssaultLawsuitC from './components/Lawsuits/RideshareSexualAssaultLawsuitC.jsx';
import SocialMediaAddictionLawsuitC from './components/Lawsuits/SocialMediaAddictionLawsuitC.jsx';
import RobloxSALawsuitC from './components/Lawsuits/RobloxSALawsuitC.jsx';
import DepoProveraLawsuitD from './components/Lawsuits/DepoProveraLawsuitD.jsx';
import TalcumPowderLawsuitD from './components/Lawsuits/TalcumPowderLawsuitD.jsx';
import HerniaMeshLawsuitD from './components/Lawsuits/HerniaMeshLawsuitD.jsx';
import OzempicLawsuitD from './components/Lawsuits/OzempicLawsuitD.jsx';
import HairRelaxerLawsuitD from './components/Lawsuits/HairRelaxerLawsuitD.jsx';
import RobloxSALawsuitD from './components/Lawsuits/RobloxSALawsuitD.jsx';
import DupixentLawsuitD from './components/Lawsuits/DupixentLawsuitD.jsx';
import DupixentLawsuitA from './components/Lawsuits/DupixentLawsuitA.jsx';
import DupixentLawsuitB from './components/Lawsuits/DupixentLawsuitB.jsx';
import DupixentLawsuitC from './components/Lawsuits/DupixentLawsuitC.jsx';
import NotFound from './components/NotFound.jsx';
import NewMedicalOzempicLawsuitB from './components/RetellFileUpload/NewMedicalOzempicLawsuitB.jsx';
ReactGA.initialize('G-4F9YEZ0JRC')

const App = () => {
   const router = createBrowserRouter([
      {
        path: "/",
        element:<HomeMain/>,  
      },
      {
        path: "/PrivacyPolicy",
        element: <PrivacyPolicy />,
      },
      {
        path: "/Disclaimer",
        element: <Disclaimer />,
      },
      {
        path: "/Services/Depo-Provera-Lawsuit",
        element: <Depomain />,
      },
      {
        path: "/Services/Toxic-Baby-Food-Lawsuit",
        element: <BabyfoodMain />,
      },
      {
        path: "/Services/Paraquat-Lawsuit",
        element: <ParaquatMain />,
      },
      {
        path: "/Services/Roundup-Lawsuit",
        element: <RoundUpMain />,
      },
      {
        path: "/Services",
        element: <ServiceMain />,
      },
      {
        path: "/AboutUs",
        element: <AboutUs />,
      },
      {
        path: "/ContactUs",
        element: <ContactUs />,
      },
      {
        path: "/Services/AFFF-FirefightingFoam-Lawsuit",
        element: <AFFFMain />,
      },
      {
        path: "/Services/Bard-PowerPort-Lawsuit",
        element: <BardPowerPortMain />,
      },
      {
        path: "/Services/Talcum-Powder-Lawsuit",
        element: <TalcumMain />,
      },
      {
        path: "/Services/Transvaginal-Mesh-Lawsuit",
        element: <TransvaginalMain />,
      },
      {
        path: "/UltraProcessedMain",
        element: <UltraProcessedMain />,
      },
      {
        path: "/Services/Oxbryta-Lawsuit",
        element: <OxbrytaMain />,
      },
      {
        path: "/Services/PFAS-Lawsuit",
        element: <PFASMain />,
      },
      {
      path: '/depo-provera-lawsuit-a',
      element: <DepoProveraLawsuit />
    },
    {
      path: '/talcum-powder-lawsuit-a',
      element: <TalcumPowderLawsuit />
    },
    {
      path: '/hernia-mesh-lawsuit-a',
      element: <HerniaMeshLawsuit />
    },
    {
      path: '/ozempic-lawsuit-a',
      element: <OzempicLawsuit />
    },
    {
      path: '/hair-relaxer-lawsuit-a',
      element: <HairRelaxerLawsuit />
    },
    {
      path: '/rideshare-sa-lawsuit-a',
      element: <RideshareSexualAssaultLawsuit />
    },
    {
      path: '/social-media-addiction-lawsuit-a',
      element: <SocialMediaAddictionLawsuit />
    },
    {
      path: '/roblox-sa-lawsuit-a',
      element: <RobloxSALawsuit />
    },
    {
      path: '/roundup-lawsuit-a',
      element: <RoundupLawsuit />
    },
    {
      path: '/depo-provera-lawsuit-b',
      element: <DepoProveraLawsuitB />
    },
    {
      path: '/talcum-powder-lawsuit-b',
      element: <TalcumPowderLawsuitB />
    },
    {
      path: '/hernia-mesh-lawsuit-b',
      element: <HerniaMeshLawsuitB />
    },
    {
      path: '/ozempic-lawsuit-b',
      element: <OzempicLawsuitB />
    },
    {
      path: '/hair-relaxer-lawsuit-b',
      element: <HairRelaxerLawsuitB />
    },
    {
      path: '/rideshare-sa-lawsuit-b',
      element: <RideshareSexualAssaultLawsuitB />
    },
    {
      path: '/social-media-addiction-lawsuit-b',
      element: <SocialMediaAddictionLawsuitB />
    },
    {
      path: '/roblox-sa-lawsuit-b',
      element: <RobloxSALawsuitB />
    },
    {
      path: '/depo-provera-lawsuit-c',
      element: <DepoProveraLawsuitC />
    },
    {
      path: '/talcum-powder-lawsuit-c',
      element: <TalcumPowderLawsuitC />
    },
    {
      path: '/hernia-mesh-lawsuit-c',
      element: <HerniaMeshLawsuitC />
    },
    {
      path: '/ozempic-lawsuit-c',
      element: <OzempicLawsuitC />
    },
    {
      path: '/hair-relaxer-lawsuit-c',
      element: <HairRelaxerLawsuitC />
    },
    {
      path: '/rideshare-sa-lawsuit-c',
      element: <RideshareSexualAssaultLawsuitC />
    },
    {
      path: '/social-media-addiction-lawsuit-c',
      element: <SocialMediaAddictionLawsuitC />
    },
    {
      path: '/roblox-sa-lawsuit-c',
      element: <RobloxSALawsuitC />
    },
    {
      path: '/depo-provera-lawsuit-d',
      element: <DepoProveraLawsuitD />
    },
    {
      path: '/talcum-powder-lawsuit-d',
      element: <TalcumPowderLawsuitD />
    },
    {
      path: '/hernia-mesh-lawsuit-d',
      element: <HerniaMeshLawsuitD />
    },
    {
      path: '/ozempic-lawsuit-d',
      element: <OzempicLawsuitD />
    },
    {
      path: '/hair-relaxer-lawsuit-d',
      element: <HairRelaxerLawsuitD />
    },
    {
      path: '/roblox-sa-lawsuit-d',
      element: <RobloxSALawsuitD />
    },
{
  path: '/dupixent-lawsuit-d',
  element: <DupixentLawsuitD />
},
{
  path: '/dupixent-lawsuit-a',
  element: <DupixentLawsuitA />
},
{
  path: '/dupixent-lawsuit-b',
  element: <DupixentLawsuitB />
},
{
  path: '/dupixent-lawsuit-c',
  element: <DupixentLawsuitC />
},
{
path:'/ozempic-lawsuit-e',
element: <NewMedicalOzempicLawsuitB />
},  
{
  path: "*",
  element: <NotFound />
},
   ])
  return (
    <div>
     <RouterProvider router={router} />
    </div>
  )
}

export default App